import React from "react";

const BASE_CLASS = "c-chat-modal-message";

export const customComponents = {
    a: (props) => (
        <a
            className={`${BASE_CLASS}__markdown-link`}
            href={props.href}
            target="_blank"
            rel="noopener noreferrer"
            {...props}>
            {props.children}
        </a>
    ),
    h1: ({ children }: { children: React.ReactNode }) => (
        <h1 className={`${BASE_CLASS}__markdown-h1`}>{children}</h1>
    ),
    h2: ({ children }: { children: React.ReactNode }) => (
        <h2 className={`${BASE_CLASS}__markdown-h2`}>{children}</h2>
    ),
    h3: ({ children }: { children: React.ReactNode }) => (
        <h3 className={`${BASE_CLASS}__markdown-h3`}>{children}</h3>
    ),
    h4: ({ children }: { children: React.ReactNode }) => (
        <h4 className={`${BASE_CLASS}__markdown-h4`}>{children}</h4>
    ),
    h5: ({ children }: { children: React.ReactNode }) => (
        <h5 className={`${BASE_CLASS}__markdown-h5`}>{children}</h5>
    ),
    hr: ({ ...props }) => (
        <hr className={`${BASE_CLASS}__markdown-hr`} {...props} />
    ),
    ol: ({
        children,
        start,
        ...props
    }: React.OlHTMLAttributes<HTMLOListElement> & {
        children?: React.ReactNode;
    }) => (
        <ol className={`${BASE_CLASS}__markdown-ol`} start={start} {...props}>
            {children}
        </ol>
    ),
    p: ({ children }: { children: React.ReactNode }) => (
        <p className={`${BASE_CLASS}__markdown-paragraph`}>{children}</p>
    ),
    table: ({ children, ...props }) => (
        <div className={`${BASE_CLASS}__markdown-table-wrapper`}>
            <table className={`${BASE_CLASS}__markdown-table`} {...props}>
                {children}
            </table>
        </div>
    ),
    thead: ({ children, ...props }) => (
        <thead className={`${BASE_CLASS}__markdown-thead`} {...props}>
            {children}
        </thead>
    ),
    tbody: ({ children, ...props }) => (
        <tbody className={`${BASE_CLASS}__markdown-tbody`} {...props}>
            {children}
        </tbody>
    ),
    tr: ({ children, ...props }) => (
        <tr className={`${BASE_CLASS}__markdown-tr`} {...props}>
            {children}
        </tr>
    ),
    th: ({ children, ...props }) => (
        <th className={`${BASE_CLASS}__markdown-th`} {...props}>
            {children}
        </th>
    ),
    td: ({ children, ...props }) => (
        <td className={`${BASE_CLASS}__markdown-td`} {...props}>
            {children}
        </td>
    ),
    ul: ({ children }: { children: React.ReactNode }) => (
        <ul className={`${BASE_CLASS}__markdown-ul`}>{children}</ul>
    ),
};
